import HuntStrategyChancesTable from "src/Tables/Order/HuntChances/HuntStrategyChancesTable";
import { getCCOrderChancesTable } from "src/Requests/ccOrder";
import ImbalanceChecksButton, { CCChanceFilter } from "./ImbalanceChecksButton";

const CCOrderChancesTable = ({ searchParam }: { searchParam: CCChanceFilter }) => <div dir="rtl" className="space-y-3">
  <div className="flex justify-start"><ImbalanceChecksButton searchParam={searchParam} /></div>
  <HuntStrategyChancesTable getData={(_, offset, pageSize) => getCCOrderChancesTable(searchParam, offset, pageSize)} />
</div>;

export default CCOrderChancesTable;
